<template>
  <section class="posts-list" :class="{ 'is-loading': loading }">
    <div class="uk-position-relative uk-width-1-1" v-if="loading">
      <div uk-spinner class="uk-position-absolute uk-position-center"></div>
    </div>

    <div uk-grid v-for="item in items" :key="item.id">
      <div class="uk-width-1-1 uk-width-auto@m">
        <a
        :href="item.link"
        class="post-image"
        :style="{backgroundImage: `url(${item.featured_image.url})` }"
        :title="item.featured_image.title"></a>
      </div>
      <div class="uk-width-1-1 uk-width-expand@m">
        <div class="post-detail">
          <span class="category" v-if="item.category">
            {{ item.category }}
          </span>

          <span class="date">
            {{ item.date_formatted }}
          </span>

          <h3>
            <a :href="item.link">
              {{ item.title.rendered }}
            </a>
          </h3>

          <div class="excerpt">
            {{ item.excerpt }}

            <a :href="item.link">Read More</a>
          </div>
        </div>
      </div>
    </div>

    <div uk-grid>
      <div class="uk-width-auto">
        <vue-pagination
          :data="pagination"
          @paginate="paginate"
        />
      </div>
    </div>
  </section>
</template>

<script>
  import VuePagination from './VuePagination';

  export default {
    data() {
      return {
        items: [],
        loading: true,
        queryDataKey: 'post_filters',
        pagination: {
          pages: 1,
          current: 1
        }
      }
    },

    props: {
      featured: {
        type: Number
      },

      filters: {
        type: Object
      },

      page: {
        type: Number
      }
    },

    watch: {
      filters: {
        handler(val){
          this.getItems(1);
        },
        deep: true
      },
    },

    components: { VuePagination },

    methods: {
      getItems (page = 1) {
        this.loading = true;

        $.get('/wp-json/wp/v2/blog', this.setFilters(page))
        .then((res, status, xhr) => {
            this.items = res;

            this.pagination = {
              current: parseInt(page),
              pages: parseInt(xhr.getResponseHeader('x-wp-totalpages'))
            }

            this.$emit('items-loaded', this.pagination);

            this.loading = false;
        });
      },

      setFilters(page) {
        let query = {
          per_page: 5,
          page: page,
          exclude: this.featured
        }

        if (this.filters.category !== 'none') {
          query.blog_category = this.filters.category;
        }

        if (this.filters.keyword) {
          query.search = this.filters.keyword;
        }

        // sessionStorage.setItem(this.queryDataKey, JSON.stringify(query));

        return query;
      },

      paginate(page) {
        this.getItems(page);
      },
    },

    created() {
      this.pagination.current = this.page;
    },

    mounted() {
      this.getItems(this.pagination.current);
    }
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/Posts.vue